/* eslint-disable max-len */
import * as R from 'ramda';
import angular from 'angular';

export default function AssignControlsToRiskTypeDialogController(
  $q,
  $rootScope,
  $scope,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  riskDataService,
  controlDataService,
  controlSharedModelService,
  editControlTypeDialog,
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditRiskControlSubmit = _handleEditRiskControlSubmit;
  vm.handleAddControlTypeDialogClick = _handleAddControlTypeDialogClick;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    $scope.$on('refreshControlTypes', () => {
      // if (data.masterVendorId === this.masterVendor.masterVendorId) {
      _refreshControlTypes();
      // }
    });
    getControlTypeList();
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.riskAdmin.assignControlsToRiskTypeDialog);
  }

  function _handleEditRiskControlSubmit() {
    if ($scope.assignControlTypeForm.$valid) {
      loaderService.showViewLoader = true;
      const controls = [];
      R.forEach(
        (item) => {
          if (item.isAssigned === true) {
            controls.push(item);
          }
        },
        vm.savedControlTypes
      );
      // if (controls.length === 0) {
      //   controls.push(-1);
      // }
      riskDataService.saveRiskControlTypes(vm.assetType.customerAssetTypeId, vm.riskType.customerRiskTypeId, controls).then((response) => {
        if (response.status === 200) {
          alerts.success('The control type for risk type has been saved successfully.');
          vm.saved = true;
          $rootScope.$broadcast('refreshControlTypesOfRiskType', { riskType: response.data });
          $rootScope.$broadcast('refreshAssetTypes');          
          $rootScope.$broadcast('refreshTopRiskTypes');
          ssDialogService.hide(ssDialogService.dialogs.riskAdmin.assignControlsToRiskTypeDialog);
        } else {
          alerts.error('Error occurred while saving the control type for risk type.');
        }
        // loaderService.showViewLoader = false;
      });
    }
  }

  function _handleAddControlTypeDialogClick($event) {
    const controlType = { customerControlTypeId: 0 };
    const promises = [
      controlDataService.getControlTypeDefaults(),
      getInitControlAdmin(),
    ];
    return $q.all(promises).then((response) => {
      loaderService.showViewLoader = false;
      controlType.controlPreventiveEffectiveness = response[0].data.controlPreventiveEffectiveness;
      controlType.controlDetectiveEffectiveness = response[0].data.controlDetectiveEffectiveness;
      controlType.controlCorrectiveEffectiveness = response[0].data.controlCorrectiveEffectiveness;
      controlType.controlAdministrativeNature = response[0].data.controlAdministrativeNature;
      controlType.controlTechnicalNature = response[0].data.controlTechnicalNature;
      controlType.controlPhysicalNature = response[0].data.controlPhysicalNature;
      controlType.controlPrimaryControlType = response[0].data.controlPrimaryControlType;
      controlType.controlCompensatingControlType = response[0].data.controlCompensatingControlType;
      controlType.controlReviewSchedule = response[0].data.controlReviewSchedule;
      // control.controlReviewType = response[0].data.controlReviewType;
      // control.controlResult = response[0].data.controlResult;
      ssDialogService.dialogs.controlAdmin.editControlTypeDialog = ssDialogService.alert(
        editControlTypeDialog.getOptions($event, {
          controlType,
          // controlResults: controlSharedModelService.ControlResults,
          controlPreventiveEffectivenesses: controlSharedModelService.ControlPreventiveEffectivenesses,
          controlDetectiveEffectivenesses: controlSharedModelService.ControlDetectiveEffectivenesses,
          controlCorrectiveEffectivenesses: controlSharedModelService.ControlCorrectiveEffectivenesses,
          controlAdministrativeNatures: controlSharedModelService.ControlAdministrativeNatures,
          controlPhysicalNatures: controlSharedModelService.ControlPhysicalNatures,
          controlTechnicalNatures: controlSharedModelService.ControlTechnicalNatures,
          controlPrimaryControlTypes: controlSharedModelService.ControlPrimaryControlTypes,
          controlCompensatingControlTypes: controlSharedModelService.ControlCompensatingControlTypes,
          controlReviewSchedules: controlSharedModelService.ControlReviewSchedules,
          // controlReviewTypes: controlSharedModelService.ControlReviewTypes,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.controlAdmin.editControlTypeDialog);
    });
  }

  function getInitControlAdmin() {
    if (controlSharedModelService.ControlPreventiveEffectivenesses && controlSharedModelService.ControlPreventiveEffectivenesses.length > 0) {
      return Promise.resolve();
    }
    return controlDataService.initControlAdmin().then((getControlInitResponse) => {
      if (!getControlInitResponse.data) {
        alerts.error('Error occurred get control init data.');
      } else {
        // if (getControlInitResponse.data.ControlResults) {
        //   controlSharedModelService.ControlResults = getControlInitResponse.data.ControlResults.result;
        // }

        if (getControlInitResponse.data.ControlPreventiveEffectivenesses) {
          controlSharedModelService.ControlPreventiveEffectivenesses = getControlInitResponse.data.ControlPreventiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlDetectiveEffectivenesses) {
          controlSharedModelService.ControlDetectiveEffectivenesses = getControlInitResponse.data.ControlDetectiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlCorrectiveEffectivenesses) {
          controlSharedModelService.ControlCorrectiveEffectivenesses = getControlInitResponse.data.ControlCorrectiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlAdministrativeNatures) {
          controlSharedModelService.ControlAdministrativeNatures = getControlInitResponse.data.ControlAdministrativeNatures.result;
        }

        if (getControlInitResponse.data.ControlPhysicalNatures) {
          controlSharedModelService.ControlPhysicalNatures = getControlInitResponse.data.ControlPhysicalNatures.result;
        }

        if (getControlInitResponse.data.ControlTechnicalNatures) {
          controlSharedModelService.ControlTechnicalNatures = getControlInitResponse.data.ControlTechnicalNatures.result;
        }

        if (getControlInitResponse.data.ControlPrimaryControlTypes) {
          controlSharedModelService.ControlPrimaryControlTypes = getControlInitResponse.data.ControlPrimaryControlTypes.result;
        }

        if (getControlInitResponse.data.ControlCompensatingControlTypes) {
          controlSharedModelService.ControlCompensatingControlTypes = getControlInitResponse.data.ControlCompensatingControlTypes.result;
        }

        if (getControlInitResponse.data.ControlReviewSchedules) {
          controlSharedModelService.ControlReviewSchedules = getControlInitResponse.data.ControlReviewSchedules.result;
        }
        //
        // if (getControlInitResponse.data.ControlReviewTypes) {
        //   controlSharedModelService.ControlReviewTypes = getControlInitResponse.data.ControlReviewTypes.result;
        // }

        // if (getControlInitResponse.data.ControlTypes) {
        //   controlSharedModelService.ControlTypes = getControlInitResponse.data.ControlTypes.result;
        // }
      }
    });
  }

  function _refreshControlTypes() {
    // const promises = [
    //   controlDataService.getControls(),
    //   _saveRisk(),
    // ];
    return controlDataService.getControlTypes().then((results) => {
      vm.controlTypes = results.data.result;
      getControlTypeList();
    });
  }

  function getControlTypeList() {
    const newControlTypes = angular.copy(vm.controlTypes);
    vm.savedControlTypes = R.map((controlType) => {
      controlType.isAssigned = false;
      let isAssigned = false;
      if (vm.riskType.customerControlTypes && vm.riskType.customerControlTypes.length > 0) {
        isAssigned = R.find(
          R.propEq('customerControlTypeId', controlType.customerControlTypeId),
          vm.riskType.customerControlTypes
        );
      }
      if (isAssigned) {
        controlType.isAssigned = true;
      }
      return controlType;
    }, newControlTypes);
  }
}

AssignControlsToRiskTypeDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'riskDataService',
  'controlDataService',
  'controlSharedModelService',
  'editControlTypeDialog'
];
